
import React from "react";
import coverGif from "../assets/Home-page-assets/home-banner-gif-bg.gif";
import globeImg from "../assets/Home-page-assets/famicons_earth-outline.png";
import rocketIcon from "../assets/Home-page-assets/icons_rocket.svg";
import TextType from "../components/ui/TextType";

const BannerSection = () => {
  return (
    <section
      className="relative min-h-[100vh] xs:min-h-[80vh] sm:min-h-[90vh] text-white overflow-hidden flex flex-col bg-cover bg-center"
      style={{ backgroundImage: `url(${coverGif})` }}
    >
      {/* Hero Section */}
      <div className="flex flex-col items-center justify-center flex-1 text-center px-6 xs:px-4 max-w-5xl mx-auto">
        <h1 className="font-goldman text-[48px] xs:text-[36px] sm:text-[50px] md:text-[60px] lg:text-[60px] font-bold leading-tight mb-2.5">
          <TextType
            text={[

              " Next-Gen API Services for a Smarter Tomorrow 🚀",

              // "Build, Integrate & Scale with Reliable API Infrastructure 🛠️",

              // "Powering Digital Innovation",
              // "with Secure & Scalable APIs",
              // "Build the Future with Us 🚀"
            ]}
            typingSpeed={75}
            pauseDuration={1500}
            showCursor={true}
            cursorCharacter="|"
          />
        </h1>

        <a
          href="https://sandbox.apigalaxy.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button
            className="mt-7 xs:mt-5 px-10 xs:px-8 py-4 xs:py-3 rounded-full border border-white/20 backdrop-blur-md flex items-center gap-3 text-[24px] xs:text-[20px] sm:text-[28px] md:text-[30px] text-white cursor-pointer transition-colors hover:bg-white/10"
          >
            <span>Explore Our APIs</span>
            {/* https://sandbox.apigalaxy.in/ */}
            <img
              src={rocketIcon}
              alt="Rocket Icon"
              className="w-[55px] h-[55px] xs:w-[40px] xs:h-[40px]"
            />
          </button>
        </a>
      </div>

      {/* Globe Illustration */}
      <div className="absolute inset-0 flex justify-center items-center z-[-10] opacity-60">
        <img
          src={globeImg}
          alt="Globe"
          className="max-h-[80%] object-contain"
        />
      </div>
    </section>
  );
};

export default BannerSection;